import React from "react";
import ReactDOM from "react-dom/client";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { BrowserRouter } from "react-router-dom";
import { MaterialUIControllerProvider } from "./context";

import { msalConfig, loadTenantAuthConfig, buildMsalConfig } from "./authConfig";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function bootstrap() {
  // Fetch per-tenant Entra config from the API before mounting.
  // This allows each tenant subdomain to use its own Entra External ID directory.
  // Falls back to the static msalConfig if the fetch fails or returns nothing.
  const tenantConfig = await loadTenantAuthConfig();
  const resolvedMsalConfig = tenantConfig ? buildMsalConfig(tenantConfig) : msalConfig;

  const msalInstance = new PublicClientApplication(resolvedMsalConfig);

  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
    ) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ErrorBoundary>
          <MaterialUIControllerProvider>
            <App instance={msalInstance} tenantAuthConfig={tenantConfig} />
          </MaterialUIControllerProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
